module.exports = "https://static.wanderu.com/ui-react/_next/static/media/fr.81d43a15.svg";